'use client';

import { useLocale, useTranslations } from 'next-intl';
import { useAisRuDomen } from '@/components/aisearch/ais-link';
import { adresSoglasiya } from '@/lib/soglasie-rassylki';

/**
 * Галочка согласия на рассылку в форме регистрации.
 *
 * Отдельная и необязательная, снята по умолчанию: согласие на рекламу
 * по 38-ФЗ (ст. 18) должно быть явным действием человека, а не условием
 * регистрации. Поэтому она стоит в своей рамке, отдельно от полей и от
 * всего, что касается условий сервиса, и регистрацию не останавливает.
 *
 * Сама галочка ничего не отправляет: Authentik сохранить её не может.
 * Решение запоминает форма при отправке (`zapomnitSRegistracii`), а в
 * API оно уходит при первом входе в кабинет.
 */
export function GalkaRassylki({
  checked,
  onChange,
  disabled,
}: {
  checked: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
}) {
  const t = useTranslations('register');
  const locale = useLocale();
  const ruDomen = useAisRuDomen();

  return (
    <div className="rounded-lg border border-[var(--color-border)] px-3 py-2.5">
      <label className="flex items-start gap-2.5 text-sm cursor-pointer">
        <input
          type="checkbox"
          name="rassylka"
          checked={checked}
          onChange={(e) => {
            onChange(e.target.checked);
          }}
          disabled={disabled}
          className="mt-1"
        />
        <span className="text-[var(--color-text)]">{t('rassylka_galka')}</span>
      </label>
      <p className="mt-1 pl-6 text-xs text-[var(--color-text-muted)] leading-relaxed">
        {t('rassylka_poyasnenie')}{' '}
        <a
          href={adresSoglasiya(ruDomen, locale)}
          target="_blank"
          rel="noopener"
          className="underline hover:text-[var(--color-text)]"
        >
          {t('rassylka_dokument')}
        </a>
      </p>
    </div>
  );
}
